import { makeChartComp } from '../../util/makeChartComp';
var LineChart = makeChartComp('Line');
export default LineChart;
